import React from 'react';
import { Route } from 'react-router-dom';

import IndexPage from 'pages/delivery/index';
import ProfilePage from 'pages/delivery/profile';
import UploadPage from 'pages/item/upload';

const collection = 'delivery';
const menuItem = ['DATABASE', 'DELIVERY'];

const routes = [
  <Route
    path={`/${collection}`}
    element={<IndexPage menuItem={menuItem} title="送貨地址管理" collection={collection} />}
  />,
  <Route
    path={`/${collection}/profile/:_id`}
    element={<ProfilePage menuItem={menuItem} title="送貨地址" collection={collection} editMode="edit" />}
  />,
  <Route
    path={`/${collection}/copy/:_id`}
    element={<ProfilePage menuItem={menuItem} title="新增送貨地址" collection={collection} editMode="copy" />}
  />,
  <Route
    path={`/${collection}/new`}
    element={<ProfilePage menuItem={menuItem} title="新增送貨地址" collection={collection} editMode="new" />}
  />,
  <Route
    path={`/${collection}/import`}
    element={<UploadPage menuItem={menuItem} title="批量新增物料" collection={collection} />}
  />
];

export default routes;
